<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top" @click="onAdd({})">
        <div class="flex-1 font-16-30313a">部门分类</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="deptList && deptList.length">
        <cate-menu :menu-data="deptList" @on-edit="onEdit" @on-delete="onDelete" @on-choose="onChooseMenu" @on-add="onAdd"
          :choose-id="chooseDeptId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex content-top mb-10">
          <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
            <div class="tab-item" :class="{ 'active': tabIndex === 0 }" @click="changeTab(0)">
              <span :class="tabIndex === 0 ? 'bg-4-46b8b0' : 'bg-4-e2'"></span>
              在职员工
            </div>
            <div class="tab-item" :class="{ 'active': tabIndex === 1 }" @click="changeTab(1)">
              <span :class="tabIndex === 1 ? 'bg-4-46b8b0' : 'bg-4-e2'"></span>
              离职员工
            </div>
          </div>
          <div class="flex ml-10">
            <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
              <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
              <el-input class="border-none" type="text" placeholder="姓名/电话" v-model="keywords" clearable
                @keyup.enter.native="onSearch"></el-input>
            </div>
            <button class="btn-30-bg-46b8b0" @click="onSearch">搜索</button>
          </div>
        </div>
        <div class="flex mb-10">
          <div class="btn-24-bg-ff flex align-center mr-5" @click="onAddEmployee" v-if="tabIndex === 0">
            <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
            新增员工
          </div>
          <div class="btn-24-bg-ff flex align-center mr-5" v-if="tabIndex === 0" @click="onChangeDept">
            <div class="tip-14-bg-46b8b0 mr-5">
              <i class="el-icon-refresh"></i>
            </div>
            调整部门
          </div>
          <div class="btn-24-bg-ff flex align-center mr-5" v-if="tabIndex === 1" @click="onDismiss(0)">
            <div class="mr-5">
              <i class="el-icon-user-solid" style="color: #46b8b0; font-size: 14px"></i>
            </div>
            恢复在职
          </div>
          <div class="btn-24-bg-ff flex align-center mr-10" v-if="tabIndex === 0" @click="onDismiss(1)">
            <img src="/static/images/customer/shangmenyubao.png" class="icon-14 mr-5" alt="">
            提交离职
          </div>
          <div class="btn-24-bg-ff flex align-center mr-10" v-if="tabIndex === 1" @click="toRemove">
            <img src="/static/images/shanchu.png" class="icon-14 mr-5" alt="">
            删除
          </div>
          <div class="flex align-center"
            style="height: 24px; line-height: 24px; border-left: 1px solid #e5e5e5; padding-left: 10px"
            v-if="chooseDept.children && chooseDept.children.length">
            <el-checkbox class="font-12-ff5555 cb-16-ff5555" @change="onSearch" v-model="isShowSub">显示子部门员工</el-checkbox>
          </div>
          <div class="flex-1"></div>
          <div class="btn-24-bd-e2 mr-5 flex align-center">
            <img src="/static/images/daoru.png" class="icon-14 mr-5" alt="">
            导入
          </div>
          <div class="btn-24-bd-e2 flex align-center" @click="exportCsvEvent">
            <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
            导出
          </div>
        </div>
        <div class="hr"></div>
        <div class="flex-1 mb-10">
          <erp-table :is-edit="true" ref="erpTable" :table-data="tableData" :loading="loading"
            :customs="[{ field: 'operate', visible: tabIndex === 0 }, { field: 'operate2', visible: tabIndex === 1 }]"
            :column-data="columnData" @on-modify="onModifyEmployee" modify-method="on-modify" @set-company="openCompany"
            @set-jurisdiction="openJurisdiction" @get-enclosure="onChooseEnclosure" @on-choose-station="onChooseStation"
            @reset-pwd="resetPwd"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
        </Pagination>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="400px" :title="isAddDept + '部门'"
      :visible.sync="isDeptShow" @closed="onCloseDept">
      <div class="p-20">
        <div class="flex align-center mb-10" v-if="isAddDept === '新增'">
          <div class="font-12-30313a mr-5">部门类型：</div>
          <el-select v-model="deptTypeValue" class="flex-1" placeholder="请选择">
            <el-option v-for="item in deptTypeArr" :key="item.type" :label="item.name" :value="item.type">
            </el-option>
          </el-select>
        </div>
        <div class="flex align-center">
          <div class="font-12-30313a mr-5">部门名称：</div>
          <el-input v-model="newDeptName" class="flex-1" placeholder="请输入部门名称"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseDept">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitDept">确定</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="70%" title="选择岗位"
      :visible.sync="isStationShow" @closed="onCloseStation">
      <div class="flex" style="height: 526px; border-bottom-right-radius: 6px; border-bottom-left-radius: 6px;">
        <div class="dialog-left">
          <el-scrollbar class="h-100 hide-x">
            <div class="dialog-left-top">
              岗位分类
            </div>
            <div v-for="(item, index) in stationTypeList" class="station-item"
              :class="{ 'active': item.id === currentStationType.id }" @click="onChooseStationType(item)" :key="index">
              <div class="index-tip">{{ index + 1 }}</div>
              <div>{{ item.name }}</div>
            </div>
          </el-scrollbar>
        </div>
        <div class="dialog-right">
          <div class="h-100">
            <erp-table :column-data="stationColData" @on-choose-station="onSubmitStation"
              :table-data="stationList"></erp-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="526" title="管辖权"
      :visible.sync="isJurisdictionShow" @closed="onCloseJurisdiction">
      <div class="flex" style="height: 500px;">
        <div class="dialog-half-left">
          <div class="dialog-left-top">
            {{ functionType === 0 ? '所辖公司' : '公司列表' }}
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div v-for="(item, index) in companyList" class="company-item"
              :class="{ 'active': item.isChecked, 'current': item.id === currentCompany.id }" :key="index">
              <div class="flex-1 flex align-center" @click="onClickCompany(item, index)">
                <span class="flex-1">{{ item.name }}</span>
                <div class="circle-16-bd-e2" v-if="functionType === 1 && !item.isChecked"></div>
                <i class="el-icon-success" style="font-size: 18px; color: #46b8b0"
                  v-if="functionType === 1 && item.isChecked"></i>
              </div>
              <el-checkbox v-model="item.isChecked" v-if="functionType === 0"></el-checkbox>
            </div>
          </el-scrollbar>
        </div>
        <div class="dialog-half-right">
          <div class="dialog-left-top">
            {{ functionType === 0 ? '所辖部门' : '调整到' }}
          </div>
          <div class="flex" style="padding-left: 20px; padding-right: 20px; padding-top: 10px;font-size: 12px;">
            <div class="flex-1 text-left font-bold" :class="{ 'active': checkAll }">全选</div>
            <div class="flex-1 justify-end text-right"><el-checkbox v-model="checkAll"
                @change="handleCheckAllChange"></el-checkbox></div>
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div class="plr-20">
              <template v-for="(item, index) in comDeptList">
                <normal-menu :menu-data="item" :index="index" :key="index" :type="functionType" :step="0"
                  @on-checked="onCheckDept"></normal-menu>
              </template>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div slot="footer" v-if="functionType === 0">
        <div class="btn-30-border-85 mr-10" @click="onCloseJurisdiction">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitJurisdiction">保存</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="526" title="公司权"
      :visible.sync="isCompanyShow" @closed="onCloseCompany">
      <div class="flex" style="height: 500px;">
        <div class="dialog-half-left">
          <div class="dialog-left-top">
            {{ functionType === 0 ? '所辖公司' : '公司列表' }}
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div v-for="(item, index) in companyList1" class="company-item"
              :class="{ 'active': item.isChecked, 'current': item.id === currentCompany1.id }" :key="index">
              <div class="flex-1 flex align-center" @click="onClickCompany1(item, index)">
                <span class="flex-1">{{ item.name }}</span>
                <div class="circle-16-bd-e2" v-if="functionType === 1 && !item.isChecked"></div>
                <i class="el-icon-success" style="font-size: 18px; color: #46b8b0"
                  v-if="functionType === 1 && item.isChecked"></i>
              </div>
              <el-checkbox v-model="item.isChecked" v-if="functionType === 0"></el-checkbox>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div slot="footer" v-if="functionType === 0">
        <div class="btn-30-border-85 mr-10" @click="onCloseCompany">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitCompany">保存</div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="590px" title="附件"
      :visible.sync="isEnclosureShow" @closed="onCloseEnclosure">
      <el-scrollbar>
        <div class="enclosure-container">
          <div class="p-20">
            <div class="mb-10" v-if="tabIndex === 0">
              <el-input type="textarea" :rows="5" resize="none" placeholder="请输入说明" v-model="enclosureInfo.description">
              </el-input>
            </div>
            <div v-else class="font-12-27 text-left">
              说明: {{ enclosureInfo.description || '无' }}
            </div>
            <div class="flex mb-5" v-if="tabIndex === 0">
              <el-upload multiple name="file" :httpRequest="httpRequestImg" :action="upload" :show-file-list="false">
                <div class="btn-24-bd-e2-bg-ff flex align-center bg-ff">
                  <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
                  上传
                </div>
              </el-upload>
            </div>
            <div class="flex flex-wrap" style="margin: 0 -5px"
              v-if="enclosureInfo.employeeOptionList && enclosureInfo.employeeOptionList.length">
              <div v-for="(item, index) in enclosureInfo.employeeOptionList" :key="index" class="enclosure-item">
                <a :href="item.path" target="_blank"><img :src="getEnclosureTypeImg(item.path)" class="type-img"
                    alt=""></a>
                <i class="el-icon-error" v-if="tabIndex === 0" @click="removeEnclosure(index)"></i>
              </div>
            </div>
            <div style="height: 100px;" class="flex align-center justify-center" v-else-if="tabIndex === 1">
              <div class="font-12-85">
                还没有上传任何附件！
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div slot="footer" v-if="tabIndex === 0">
        <div class="btn-30-border-85 mr-10" @click="onCloseEnclosure">取消</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitEnclosure">保存</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import CateMenu from '../../components/CateMenu'
import NormalMenu from '../../components/NormalMenu'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'employeeDefine',
  components: { Pagination, MoveHorizon, CateMenu, ErpTable, NormalMenu },
  data () {
    return {
      checkAll: true,
      check: true,
      // isIndeterminate: true,
      companyList: [],
      companyList1: [],
      comDeptList: [],
      deptList: [],
      chooseDeptId: 0,
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      employeeList: [],
      isAddDept: '',
      isDeptShow: false,
      isStationShow: false,
      isJurisdictionShow: false,
      isShowSub: false,
      isEnclosureShow: false,
      isCompanyShow: false,
      loading: true,
      currentDept: {},
      chooseDept: {},
      keywords: '',
      tableData: [],
      stationTypeList: [],
      deptTypeArr: [
        {
          name: '公司部门',
          type: 1
        }, {
          name: '项目经理部门',
          type: 2
        }
      ],
      deptTypeValue: '',
      newDeptName: '',
      tabIndex: 0,
      currentStationType: {},
      stationList: [],
      employeeArr: [],
      currentStation: {},
      currentEmp: {},
      currentCompany: [],
      currentCompany1: [],
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      enclosureInfo: {},
      functionType: 0,
      columnData: [
        {
          type: 'selection',
          width: '40'
        },
        {
          field: 'operate',
          title: '操作',
          width: '350',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '选择岗位',
            methodName: 'on-choose-station',
            type: 'btn'
          }, {
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '附件',
            methodName: 'get-enclosure',
            type: 'btn'
          }, {
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '重置密码',
            methodName: 'reset-pwd',
            type: 'btn'
          }]
        },
        {
          field: 'operate2',
          title: '操作',
          width: '120',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '附件',
            methodName: 'get-enclosure',
            type: 'btn'
          }, {
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '重置密码',
            methodName: 'reset-pwd',
            type: 'btn'
          }]
        },
        {
          field: 'name',
          title: '名字',
          width: '90',
          editRender: {
            name: 'input'
          }
        },
        {
          field: 'gender',
          title: '性别',
          width: '90',
          formatter: 'toSex',
          editType: 'select',
          editRender: {
            name: 'select',
            options: [
              {
                value: 1,
                label: '男'
              },
              {
                value: 2,
                label: '女'
              }
            ]
          }
        },
        {
          field: 'telephone',
          title: '电话号码',
          width: '115',
          editRender: {
            name: 'input'
          },
          editType: 'tel'
        },
        {
          field: 'roleName',
          title: '岗位',
          width: '180'
        },
        {
          field: 'departmentName',
          title: '部门',
          width: '99'
        },
        {
          field: 'idNumber',
          title: '身份证号',
          width: '160',
          editRender: {
            name: 'input'
          }
        },
        {
          field: 'birthday',
          title: '生日',
          minWidth: '120',
          editRender: {
            name: 'input'
          },
          editType: 'date', // 为日期的编辑
          dateConfig: { // 为日期时必填  用来区分是日期还是日期+时间
            format: 'yyyy-MM-dd',
            type: 'date', // 显示类型 year/month/date/dates/ week/datetime/datetimerange/ daterange/monthrange  默认date
            valueFormat: 'yyyy-MM-dd' // yyyy-MM-dd/timestamp 参照https://element.eleme.cn/#/zh-CN/component/date-picker#ri-qi-ge-shi
          }
        }
      ],
      stationColData: [
        {
          field: 'operate',
          title: '操作',
          width: '68',
          isDefine: true,
          child: [{
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
            title: '选择',
            methodName: 'on-choose-station',
            type: 'btn'
          }]
        },
        {
          field: 'name',
          title: '岗位',
          width: '180'
        },
        {
          field: 'remark',
          title: '说明',
          minWidth: '200'
        }
      ],
      isCanHandle: false
    }
  },
  created () {
    let that = this
    this.axios.post('permission/permissionStr', { parent: 'employeeDefine', parentGroup: 'employeeDefine' }).then(res => {
      if (res.data.data.indexOf('jurisdictionCompany') > -1) {
        let btn = {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '公司权',
          methodName: 'set-company'
        }
        let operateColumn = that.columnData[1]
        operateColumn.child.push(btn)
        that.$set(that.columnData, 1, operateColumn)
      }
      if (res.data.data.indexOf('jurisdiction') > -1) {
        let btn = {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '管辖权',
          methodName: 'set-jurisdiction'
        }
        let operateColumn = that.columnData[1]
        operateColumn.child.push(btn)
        that.$set(that.columnData, 1, operateColumn)
      }
    })
    this.getAllDept()
    this.getStationType()
  },
  mounted () { },
  methods: {
    getOpsition (id) {
      let params = {
        stationId: id
      }
      this.axios.post('station/judgeRightValue', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          this.isCanHandle = true
        } else {
          this.isCanHandle = false
        }
      })
    },
    resetPwd (row) {
      this.getOpsition(row.id)
      this.loading1 = this.$loading({
        lock: true,
        text: '权职判断中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.8)'
      })
      setTimeout(() => {
        console.log(this.isCanHandle)
        if (this.isCanHandle) {
          this.loading1.close()
          let params = {
            id: row.id
          }
          this.axios.post('employee/resetPassword', this.qs.stringify(params)).then(res => {
            if (res.data.success) {
              if (row.id === this.$store.state.user.id) {
                this.$store.dispatch('removeUser', {})
                this.$router.replace('/login')
              }
              this.$message({
                message: '重置密码成功',
                type: 'success',
                duration: 1000,
                offset: 200
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                duration: 1000,
                offset: 400
              })
            }
          })
        } else {
          this.$message({
            message: '您权职不够，不能操作',
            type: 'warning',
            offset: 400
          })
        }
      }, 1000)
    },
    handleCheckAllChange (val) {
      if (this.comDeptList.length > 0) {
        for (let i = 0; i < this.comDeptList.length; i++) {
          this.comDeptList[i].isChecked = this.checkAll
          if (this.comDeptList[i].children) {
            this.changeChecked(this.comDeptList[i].children)
          }
        }
      }
    },
    changeChecked (list) {
      for (let i = 0; i < list.length; i++) {
        list[i].isChecked = this.checkAll
        if (list[i].children) {
          this.changeChecked(list[i].children)
        }
      }
    },
    exportCsvEvent () {
      this.$refs.erpTable.exportCsv()
    },
    submitCompany () {
      let employeeComList = []
      for (let i = 0; i < this.companyList1.length; i++) {
        if (this.companyList1[i].isChecked) {
          let info = {
            employeeId: this.currentEmp.id,
            companyId: this.companyList1[i].id
          }
          employeeComList.push(info)
        }
      }
      if (employeeComList.length === 0) {
        employeeComList.push({
          employeeId: this.currentEmp.id
        })
      }
      this.axios.post('employeeCompany/save', employeeComList).then(res => {
        if (res.data.success) {
          this.$message({
            message: '所辖公司设置成功',
            type: 'success',
            duration: 1000,
            offset: 200
          })
        } else {
          this.$message({
            message: '设置所辖公司失败: ' + res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 400
          })
        }
      })
    },
    submitJurisdiction () {
      let employeeComList = []
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.companyList[i].isChecked) {
          let info = {
            employeeId: this.currentEmp.id,
            companyId: this.companyList[i].id
          }
          employeeComList.push(info)
        }
      }
      if (employeeComList.length === 0) {
        employeeComList.push({
          employeeId: this.currentEmp.id
        })
      }
      this.axios.post('employeeCompany/save', employeeComList).then(res => {
        if (res.data.success) {
          this.$message({
            message: '所辖公司设置成功',
            type: 'success',
            duration: 1000,
            offset: 200
          })
        } else {
          this.$message({
            message: '设置所辖公司失败: ' + res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 400
          })
        }
      })
      let employeeDepartmentList = []
      this.getEmpDeptList(this.comDeptList, employeeDepartmentList)
      if (employeeDepartmentList.length === 0) {
        employeeDepartmentList.push({
          employeeId: this.currentEmp.id,
          companyId: this.currentCompany.id
        })
      }
      // if (employeeDepartmentList.length === 0) {
      //   employeeDepartmentList.push({
      //     employeeId: this.currentEmp.id,
      //     companyId: this.currentEmp.companyId
      //   })
      // }
      this.axios.post('employeeDepartment/save', employeeDepartmentList).then(res => {
        if (res.data.success) {
          this.$message({
            message: '所辖部门设置成功',
            type: 'success',
            duration: 1000,
            offset: 200
          })
          this.isJurisdictionShow = false
        } else {
          this.$message({
            message: '设置所辖部门失败: ' + res.data.msg,
            type: 'error',
            duration: 1000,
            offset: 400
          })
        }
      })
    },
    getEmpDeptList (list, employeeDepartmentList) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].isChecked) {
          let info = {
            employeeId: this.currentEmp.id,
            departmentId: list[i].id,
            companyId: list[i].companyId
          }
          employeeDepartmentList.push(info)
        }
        if (list[i].children && list[i].children.length) {
          this.getEmpDeptList(list[i].children, employeeDepartmentList)
        }
      }
    },
    onCheckDept (isChecked, index, dept) {
      if (isChecked && this.functionType === 1) {
        let employeeArr = this.employeeArr
        let idArr = []
        let nameArr = []
        let that = this
        for (let i = 0; i < employeeArr.length; i++) {
          idArr.push(employeeArr[i].id)
          nameArr.push(employeeArr[i].name)
        }
        this.$confirm(`是否将${nameArr.join('、')}调整到${dept.name}？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(','),
            departmentId: dept.id
          }
          that.axios.post('employee/modify', params).then(res => {
            if (res.data.success) {
              that.$message({
                message: '部门调整成功',
                type: 'success'
              })
              that.getEmployee()
              that.$refs.erpTable.setAllSelection(false)
              that.isJurisdictionShow = false
            } else {
              that.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        }).catch(e => {
          that.$message.info('已取消操作')
          dept.isChecked = !isChecked
          this.$set(this.comDeptList, index, dept)
        })
      }
    },
    onClickCompany1 (company, index) {
      // if (company.id !== this.currentCompany.id) {
      //   this.currentCompany1 = company
      // }
      this.currentCompany1 = company
    },
    onClickCompany (company, index) {
      // if (company.id !== this.currentCompany1.id) {
      //   this.currentCompany = company
      //   this.getCompanyDept()
      // }
      this.currentCompany = company
      this.getCompanyDept()
    },
    openCompany (row) {
      this.currentEmp = row
      this.functionType = 0
      this.axios.post('company/listForAll', this.qs.stringify({ employeeId: row.id })).then(res => {
        if (res.data.success) {
          this.companyList1 = res.data.data
          this.isCompanyShow = true
          if (res.data.data.length) {
            this.currentCompany1 = res.data.data[0]
          }
        }
      })
    },
    openJurisdiction (row) {
      let that = this
      this.getOpsition(row.id)
      this.loading1 = this.$loading({
        lock: true,
        text: '权职判断中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.8)'
      })
      setTimeout(() => {
        console.log(this.isCanHandle)
        if (this.isCanHandle) {
          this.loading1.close()
          this.currentEmp = row
          this.functionType = 0
          this.axios.post('company/listForAll', this.qs.stringify({ employeeId: row.id, companyFlag: 1 })).then(res => {
            if (res.data.success) {
              this.companyList = res.data.data
              if (res.data.data.length) {
                that.currentCompany = res.data.data[0]
                that.getCompanyDept()
                that.isJurisdictionShow = true
              }
            }
          })
        } else {
          this.$message({
            message: '您权职不够，不能操作',
            type: 'warning',
            offset: 400
          })
        }
      }, 1000)
    },
    onChangeDept () {
      let employeeArr = this.$refs.erpTable.getSelectEvent()
      if (!employeeArr.length) {
        this.$message({
          message: `请先选择要调整部门的员工`,
          type: 'warning'
        })
      } else {
        this.employeeArr = employeeArr
        this.functionType = 1
        this.axios.post('company/listForAll').then(res => {
          if (res.data.success) {
            this.companyList = res.data.data
            if (res.data.data.length) {
              this.currentCompany = res.data.data[0]
              this.currentCompany.isChecked = true
              this.getCompanyDept2()
              this.isJurisdictionShow = true
            }
          }
        })
      }
    },
    judgeCheckAllChange () {
      // debugger
      this.checkAll = true
      if (this.comDeptList.length > 0) {
        for (let i = 0; i < this.comDeptList.length; i++) {
          if (!this.comDeptList[i].isChecked) {
            this.checkAll = false
            return this.checkAll
          }
          if (this.comDeptList[i].children.length > 0) {
            this.checkAll = this.judgeChecked(this.comDeptList[i].children)
            return this.checkAll
          }
        }
      } else {
        this.checkAll = false
        return this.checkAll
      }
    },
    judgeChecked (list) {
      // debugger
      let checked = true
      for (let i = 0; i < list.length; i++) {
        if (!list[i].isChecked) {
          checked = false
          return checked
        }
        if (list[i].children.length > 0) {
          // debugger
          checked = this.judgeChecked(list[i].children)
          return checked
        }
      }
      return checked
    },
    getCompanyDept () {
      this.axios.post('department/findAll', { companyId: this.currentCompany.id, employeeId: this.currentEmp.id }).then(res => {
        if (res.data.success) {
          this.comDeptList = res.data.data
          this.judgeCheckAllChange()
        }
      })
    },
    // 级联获取部门
    getCompanyDept2 () {
      this.axios.post('department/findAll', { companyId: this.currentCompany.id }).then(res => {
        if (res.data.success) {
          this.comDeptList = res.data.data
          this.judgeCheckAllChange()
        }
      })
    },
    onCloseCompany () {
      this.isCompanyShow = false
    },
    onCloseJurisdiction () {
      this.isJurisdictionShow = false
    },
    removeEnclosure (index) {
      this.$confirm('点击保存之后才能真正删除该附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.enclosureInfo.employeeOptionList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 3)
      formData.append('description', '')
      let that = this
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        that.enclosureInfo.employeeOptionList.push({
          path: onloadRes.data.data.path
        })
      }).catch(() => {
        this.$message.error('上传失败！')
      })
    },
    onCloseEnclosure () {
      this.isEnclosureShow = false
    },
    submitEnclosure () {
      if (!this.enclosureInfo.employeeOptionList.length) {
        this.$message({
          type: 'warning',
          message: '请选择您要上传的附件'
        })
      } else {
        this.axios.post('employee/modifyByOption', this.enclosureInfo).then(res => {
          if (res.data.success) {
            this.getEmployee()
            this.$message({
              message: '附件上传成功',
              type: 'success'
            })
            this.isEnclosureShow = false
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    getEnclosureTypeImg (path) {
      let type = path.substring(path.lastIndexOf('.') + 1)
      switch (type.toLowerCase()) {
        case 'doc':
        case 'docx':
          return '/static/images/word.png'
        case 'pdf':
          return '/static/images/pdf.png'
        case 'ppt':
          return '/static/images/ppt.png'
        case 'xls':
        case 'xlsx':
          return '/static/images/excel.png'
        case 'dwg':
          return '/static/images/cad.png'
        case 'txt':
          return '/static/images/txt.png'
        default:
          return '/static/images/other.png'
      }
    },
    onSubmitStation (row) {
      let params = {
        id: this.currentEmp.id,
        roleId: row.id
      }
      this.axios.post('employee/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: row.name + '选择成功!',
            type: 'success'
          })
          this.getEmployee()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseStationType (stationType) {
      this.currentStationType = stationType
      this.getStation()
    },
    // 选择附件
    onChooseEnclosure (row) {
      this.getOpsition(row.id)
      this.loading1 = this.$loading({
        lock: true,
        text: '权职判断中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.8)'
      })
      setTimeout(() => {
        console.log(this.isCanHandle)
        if (this.isCanHandle) {
          this.loading1.close()
          this.enclosureInfo = {
            id: row.id,
            description: row.description,
            employeeOptionList: row.employeeOptionList || []
          }
          this.isEnclosureShow = true
        } else {
          this.$message({
            message: '您权职不够，不能操作',
            type: 'warning',
            offset: 400
          })
        }
      }, 1000)
    },
    // 选择岗位
    onChooseStation (row) {
      this.getOpsition(row.id)
      this.loading1 = this.$loading({
        lock: true,
        text: '权职判断中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.8)'
      })
      setTimeout(() => {
        console.log(this.isCanHandle)
        if (this.isCanHandle) {
          this.loading1.close()
          this.currentEmp = row
          this.isStationShow = true
        } else {
          this.$message({
            message: '您权职不够，不能操作',
            type: 'warning',
            offset: 400
          })
        }
      }, 1000)
    },
    // 删除
    toRemove () {
      let employeeArr = this.$refs.erpTable.getSelectEvent()
      if (!employeeArr.length) {
        this.$message({
          message: `请先选择要删除的员工`,
          type: 'warning'
        })
      } else {
        let idArr = []
        let nameArr = []
        let that = this
        for (let i = 0; i < employeeArr.length; i++) {
          idArr.push(employeeArr[i].id)
          nameArr.push(employeeArr[i].name)
        }
        this.$confirm(`是否将${nameArr.join('、')}彻底删除？删除后不可恢复！`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(',')
          }
          that.axios.post('employee/deleteByIds', this.qs.stringify(params)).then(res => {
            if (res.data.success) {
              that.$message({
                message: '删除成功',
                type: 'success'
              })
              that.getEmployee()
              that.$refs.erpTable.setAllSelection(false)
            } else {
              that.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    // 离职
    onDismiss (type) {
      let text = type === 0 ? '恢复在职' : '提交离职'
      let employeeArr = this.$refs.erpTable.getSelectEvent()
      if (!employeeArr.length) {
        this.$message({
          message: `请先选择要${text}的员工`,
          type: 'warning'
        })
      } else {
        let idArr = []
        let nameArr = []
        let that = this
        for (let i = 0; i < employeeArr.length; i++) {
          idArr.push(employeeArr[i].id)
          nameArr.push(employeeArr[i].name)
        }
        this.$confirm(`是否将${nameArr.join('、')}${text}？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(','),
            isQuit: type
          }
          that.axios.post('employee/modify', params).then(res => {
            if (res.data.success) {
              that.$message({
                message: text + '成功',
                type: 'success'
              })
              that.getEmployee()
              that.$refs.erpTable.setAllSelection(false)
            } else {
              that.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    onModifyEmployee (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('employee/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
          this.$refs.erpTable.revertData(row)
        }
      })
    },
    onAddEmployee () {
      this.axios.post('employee/save', { departmentId: this.chooseDeptId, gender: 1 }).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.tableData[0], 'name')
          this.total++
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onSearch () {
      this.page = 1
      this.chooseDeptId = ''
      this.getEmployee(true)
    },
    submitDept () {
      if (!this.deptTypeValue && !this.currentDept.type) {
        this.$message({
          message: '请选择部门类型',
          type: 'warning'
        })
      } else if (!this.newDeptName) {
        this.$message({
          message: '请输入部门名称',
          type: 'warning'
        })
      } else {
        let that = this
        let callBack = function (res, type) {
          if (res.data.success) {
            that.$message({
              message: that.isAddDept + '成功',
              type: 'success'
            })
            that.deptTypeValue = ''
            that.newDeptName = ''
            that.isDeptShow = false
            that.currentDept = {}
            if (type === 1) {
              that.Utils.updateList(that.deptList, 1, res.data.data)
            } else {
              that.Utils.updateList(that.deptList, 0, res.data.data)
            }
            // that.getAllDept(true)
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        }
        if (this.isAddDept === '新增') {
          let params = {
            type: this.deptTypeValue || this.currentDept.type,
            name: this.newDeptName,
            companyId: this.$store.state.companyId,
            path: this.currentDept.id ? this.currentDept.path + ',' + this.currentDept.id : '',
            parentId: this.currentDept.id
          }
          this.axios.post('department/save', params).then(res => {
            callBack(res, 0)
          })
        } else {
          let params = {
            id: this.currentDept.id,
            name: this.newDeptName
          }
          this.axios.post('department/modify', params).then(res => {
            callBack(res, 1)
          })
        }
      }
    },
    onCloseDept () {
      this.deptTypeValue = ''
      this.newDeptName = ''
      this.isDeptShow = false
    },
    onCloseStation () {
      this.isStationShow = false
    },
    changeTab (tabIndex) {
      this.tabIndex = tabIndex
      this.page = 1
      this.getEmployee()
    },
    getEmployee (isSearch) {
      this.loading = true
      let param = {
        page: this.page,
        limit: this.limit,
        departmentId: this.chooseDeptId,
        isQuit: this.tabIndex,
        keywords: this.keywords,
        isShowSub: this.isShowSub
      }
      if (isSearch) {
        param.companyId = this.$store.state.companyId
      }
      if (param.page === 1) {
        this.employeeList = []
      }
      this.axios.post('employee/queryForPage', param).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    getAllDept (notRefresh) {
      this.deptList = []
      this.axios.post(`department/findAll`, { companyId: this.$store.state.companyId }).then(res => {
        this.deptList = res.data.data
        if (!notRefresh) {
          this.getDefaultId(this.deptList)
        }
      })
    },
    getStationType () {
      this.stationTypeList = []
      // this.axios.post(`stationClassify/list`, {companyId: this.$store.state.companyId}).then(res => {
      this.axios.post(`stationClassify/list`, {}).then(res => {
        this.stationTypeList = res.data.data
        if (res.data.data.length) {
          this.currentStationType = res.data.data[0]
          this.getStation()
        }
      })
    },
    getStation () {
      this.stationList = []
      this.axios.post(`station/list`, { classifyId: this.currentStationType.id, status: 1 }).then(res => {
        this.stationList = res.data.data
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let dept = list[0]
        // if (dept.children && dept.children.length) {
        //   this.getDefaultId(dept.children)
        // } else {
        this.chooseDeptId = dept.id
        this.chooseDept = dept
        this.getEmployee()
        // }
      }
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getEmployee()
    },
    openModel () {
      this.isDialogShow = true
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseDeptId) {
        this.chooseDeptId = menu.id
        this.chooseDept = menu
        this.page = 1
        this.keywords = ''
        this.getEmployee()
      }
    },
    onAdd (menu) {
      this.isAddDept = '新增'
      this.isDeptShow = true
      this.currentDept = menu
    },
    onDelete (menu) {
      let that = this
      this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('department/deleteById', that.qs.stringify({ id: menu.id })).then(res => {
          if (res.data.success) {
            // that.getAllDept(that.chooseDeptId !== menu.id)
            that.Utils.updateList(that.deptList, 2, { id: res.data.data })
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onEdit (menu) {
      this.isAddDept = '修改'
      this.isDeptShow = true
      this.currentDept = menu
      this.newDeptName = menu.name
    },
    isInArray (arr, value) {
      this.Utils.isInArray(arr, value)
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.chooseDeptId = ''
        this.getEmployee(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  color: #46b8b0;
}

.horizon-container {
  .dialog-half-left {
    flex: 1;
    background: #ffffff;
    height: 100%;
    border-right: 1px dashed #e2e2e2;
    display: flex;
    flex-direction: column;

    .company-item {
      height: 35px;
      line-height: 35px;
      display: flex;
      padding: 0 20px;
      font-size: 12px;
      color: #30313a;
      text-align: left;
      cursor: pointer;

      &.active {
        color: #46b8b0;
      }

      &.current {
        color: #46b8b0;
        background: #f3f4f7;
      }
    }
  }

  .dialog-half-right {
    flex: 1;
    background: #f3f4f7;
    display: flex;
    flex-direction: column;
  }

  .enclosure-container {
    max-height: 300px;

    .enclosure-item {
      width: 70px;
      height: 70px;
      background-color: #f3f4f7;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 5px 0;

      .type-img {
        width: 38px;
        height: 42px;
      }

      i {
        width: 14px;
        height: 14px;
        color: #ff5555;
        cursor: pointer;
        position: absolute;
        top: 2px;
        right: 2px;
      }
    }
  }

  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }

  .content-top {
    height: 30px;

    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;

      span {
        height: 16px;
      }

      &.active {
        color: #46b8b0;
      }
    }
  }

  .dialog-left-top {
    height: 40px;
    border-bottom: 1px solid #e2e2e2;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
    color: #30313a;
    text-align: left;
    background-color: #ffffff;
  }

  .dialog-left {
    width: 200px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 6px;
    z-index: 9;

    .station-item {
      cursor: pointer;
      display: flex;
      padding: 0 20px;
      align-items: center;
      font-size: 14px;
      color: #30313a;
      height: 35px;
      line-height: 35px;
      border-bottom: 1px dashed #e2e2e2;

      .index-tip {
        width: 20px;
        text-align: center;
        height: 14px;
        line-height: 14px;
        background-color: #b9b9b9;
        border-radius: 4px;
        font-size: 10px;
        color: #ffffff;
        margin-right: 5px;
      }

      &.active {
        color: #46b8b0;

        .index-tip {
          background-color: #46b8b0;
          color: #ffffff;
        }
      }
    }
  }

  .dialog-right {
    border-bottom-right-radius: 6px;
    flex: 1;
    background-color: #f3f4f7;
    padding: 10px 20px 20px;
  }
}

.search {
  overflow: hidden;
}

.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/administrative/employeeDefine.vue